import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
	selector: 'app-loading-card',
	templateUrl: './loading-card.component.html',
	styleUrls: ['./loading-card.component.scss']
})
export class LoadingCardComponent implements OnInit {
	@Input() showSpacing = false;

	public pageHeading: string;
	public options: AnimationOptions = {
		path: './assets/animations/loading.json'
	};

	constructor(private translateService: TranslateService) {}

	ngOnInit() {
		this.pageHeading = this.translateService.instant(
			'sbb_loadingCard_titleOne'
		);

		setTimeout(() => {
			this.pageHeading = this.translateService.instant(
				'sbb_loadingCard_titleTwo'
			);
		}, 60000);
	}
}
